import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";

import Home from "./components/Home";
import MCQList from "./components/MCQList";
import AdminPanel from "./components/AdminPanel";
import Auth from "./components/Auth";
import TestPage from "./components/TestPage";
import UserDashboard from "./components/UserDashboard";
import ResultPage from "./components/ResultPage";

import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import { AuthProvider, useAuth } from "./context/AuthContext";

import "./styles.css";

/* ---------------- NAVBAR ---------------- */
function Navbar({ dark, setDark }) {
  const { user, logout } = useAuth();

  return (
    <nav className="navbar">
      <Link to="/" className="logo-link">
        <h2>CSS / PMS MCQ Prep</h2>
      </Link>

      <div className="nav-buttons">
        <Link to="/browse/General" className="nav-btn">
          Browse MCQs
        </Link>

        <Link to="/test" className="nav-btn">
          Start Test
        </Link>

        {user && (
          <Link to="/dashboard" className="nav-btn">
            Dashboard
          </Link>
        )}

        {user?.role === "admin" && (
          <Link to="/admin" className="nav-btn">
            Admin
          </Link>
        )}

        {user ? (
          <button
            className="nav-btn"
            onClick={() => {
              logout();
              window.location.href = "/";
            }}
          >
            Logout
          </button>
        ) : (
          <Link to="/auth" className="nav-btn">
            Login / Signup
          </Link>
        )}

        <button
          className="theme-toggle"
          onClick={() => setDark(!dark)}
        >
          {dark ? "☀ Light" : "🌙 Dark"}
        </button>
      </div>
    </nav>
  );
}

/* ---------------- RESULT ROUTE WRAPPER ---------------- */
function ResultWrapper() {
  const location = useLocation();

  if (!location.state?.result) {
    return <Navigate to="/" replace />;
  }

  return <ResultPage result={location.state.result} />;
}

/* ---------------- APP ---------------- */
export default function App() {
  const [dark, setDark] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <div data-theme={dark ? "dark" : "light"}>
          <Navbar dark={dark} setDark={setDark} />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse/:subject" element={<MCQList />} />
            <Route path="/auth" element={<Auth />} />

            <Route
              path="/test"
              element={
                <ProtectedRoute>
                  <TestPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/result"
              element={
                <ProtectedRoute>
                  <ResultWrapper />
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}
